// extracted by css-extract-rspack-plugin
export default {"cls1":"Thumbnail-cls1_hNE","cls2":"Thumbnail-cls2_1U_ Thumbnail-cls1_hNE"};